// import React, {useState} from 'react'
import '../Pages/style.css'
import { RiCloseCircleFill } from "react-icons/ri";
import checkicon from '../assets/checkicon.svg';

const Confirm = ({closeOverlay, message}) => {
    const handleClose = () =>{
        // setClose(!close)
        closeOverlay(true)
    }
//Email Verified! Click on the Download Button
  return (
    <div className='errorContainer'>
        <div className='errorSubContain'>
            <div className='ClsiconContain'><RiCloseCircleFill onClick={handleClose} id='closeIcon'/></div>
            <div className='iconContainer'><img src={checkicon} alt="iconImage"  id='errorIcon'/></div>
            <span id="errorInfo">{message}</span>
        </div>
    </div>
  )
}

export default Confirm
